import { createFileRoute } from '@tanstack/react-router';

import { PublishingPage } from '@/features/publishing/components/publishing-page';

export const Route = createFileRoute('/_app/publishing/')({
    component: PublishingPage
});
